import hyperdom from 'hyperdom'

export default function ({inputBinding,
  selectBinding,
  classes,
  selectId,
  selectOnBlur,
  options} = {}) {
  const _inputBinding = hyperdom.binding(inputBinding)
  const _selectBinding = hyperdom.binding(selectBinding)

  return hyperdom.viewComponent({
    onadd (htmlElement) {
      const input = htmlElement.getElementsByTagName('input')[0]
      const select = htmlElement.getElementsByTagName('select')[0]
      select.onfocus = () => {
        input.classList.add('focused')
      }
      select.onblur = () => {
        selectOnBlur && selectOnBlur()
        input.classList.remove('focused')
      }
    },
    render () {
      const {wrapper, input, select} = classes || {}
      const wrapperClass = wrapper || ''
      const inputClass = input || ''
      const selectClass = select || ''
      return <div class={`customSelect ${wrapperClass}`}>
        <input
          class={`customSelect__input ${inputClass}`}
          tabIndex="-1"
          binding={_inputBinding}
        />
        <select class={`customSelect__select ${selectClass}`}
          id={selectId || ''}
          required
          binding={_selectBinding}>
          {
            options.map(option => <option value={option.value}>
              {option.display}
            </option>)
          }
        </select>
      </div>
    },
  })
}
